// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"ReportsFilters-primaryButton-OrYHdv","filtersSection":"ReportsFilters-filtersSection-2oMXYw"};